import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { LiveQuery } from './LiveQuery'

export class UserLiveQuery extends LiveQuery {
    static objectLib: any | undefined

    public async init() {
        if (!UserLiveQuery.objectLib) UserLiveQuery.objectLib = await ToktokdocLib.User.findOne(this.objectId)
    }

    public async onPendingConsultationCreateOrEnter() {
        this.restartCallBack = this.onPendingConsultationCreateOrEnter
        this.subscription = await UserLiveQuery.objectLib.onPendingConsultationCreateOrEnter(async (user: any) => {
            this.callback(user)
        })
        this.createLiveQuery()
    }

    public async onPendingConsultationLeave() {
        this.restartCallBack = this.onPendingConsultationLeave
        this.subscription = await UserLiveQuery.objectLib.onPendingConsultationLeave(async (user: any) => {
            this.callback(user)
        })
        this.createLiveQuery()
    }

    public async onTransmitedTransmissionLeave() {
        this.restartCallBack = this.onTransmitedTransmissionLeave
        this.subscription = await UserLiveQuery.objectLib.onTransmitedTransmissionLeave(async (user: any) => {
            this.callback(user)
        })
        this.createLiveQuery()
    }

    public async onPendingTransmissionCreateOrEnter() {
        this.restartCallBack = this.onPendingTransmissionCreateOrEnter
        this.subscription = await UserLiveQuery.objectLib.onPendingTransmissionCreateOrEnter(async (user: any) => {
            this.callback(user)
        })
        this.createLiveQuery()
    }
}
